// extracted by mini-css-extract-plugin
export default {"container":"Products_container__uOSVt","products":"Products_products__GYkd7","menu":"Products_menu__pUAZb","list":"Products_list__qrias","product":"Products_product__LX8bs"};